/* global $ toastr */

import React, { Component } from 'react';
import { store } from '../../../index'
import { request } from '../../lib/utils'


export class ModalOrderColumn extends Component {

  constructor(props) {
    super(props)

    this.changeFields = this.changeFields.bind(this)
    this.applyChange = this.applyChange.bind(this)
    this.getColumns = this.getColumns.bind(this)
    // this.componentDidUpdate = this.componentDidUpdate.bind(this)

    this.state = {
      user_table_headers: null,
    }
  }

  componentDidMount() {
    this.setState({ user_table_headers: this.props.user_table_headers })
  }

  getColumns() {
    const user_table_headers = this.state.user_table_headers
    return user_table_headers ? user_table_headers : this.props.table_headers
  }

  changeFields(idx, action) {
    let columns = [...this.getColumns()]

    if (action == "trash") {
      columns.splice(idx, 1);
    }

    if (action == "down") {
      var element = columns[idx];
      columns.splice(idx, 1);
      columns.splice(idx + 1, 0, element);
    }

    if (action == "up") {
      var element = columns[idx];
      columns.splice(idx, 1);
      columns.splice(idx - 1, 0, element);
    }

    this.setState({ user_table_headers: columns })
  }

  applyChange(action) {
    const user_table_headers = action == "reset" ? [] : this.state.user_table_headers
    const project_name = this.props.project_name

    request({
      method: 'post',
      url: `/api/${project_name}/set_user_conf`,
      data: {
        user_table_headers: user_table_headers,
      },
      success: (data) => {
        toastr.info("Настройки сохранены")
        store.dispatch({
          type: `${project_name}_columns_change`,
          user_table_headers: action == "reset" ? undefined : user_table_headers
        })
      }
    })
  }

  render() {
    const attrs = this.props.attrs
    const current_columns = this.getColumns()
    const td_icon_style = { width: "50px" }

    const disabled_cols = this.props.table_headers.map(attr_name => {
      if (!current_columns.includes(attr_name)) {
        const attr = attrs[attr_name]

        const restoreField = () => {
          this.setState({ user_table_headers: [...this.getColumns(), attr_name] })
        }

        return <span className="badge text-bg-secondary me-1 mb-1 pointer" onClick={restoreField} key={attr_name}>
          {attr.title}
        </span>
      }
    })

    return (
      <div className="modal fade" id="modal_order_column" tabIndex="-1" aria-hidden="true" key="modal_order_column">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel1">Настройка колонок</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <table className="table table-hover mb-3">
                <tbody>
                  {current_columns.map((attr_name, idx) => {
                    const attr = attrs[attr_name]

                    if (attr) {
                      return <tr key={attr_name}>
                        <td>
                          {attr.title}
                        </td>
                        <td style={td_icon_style}>
                          <span className="ti ti-circle-arrow-up pointer" onClick={() => { this.changeFields(idx, "up") }}></span>
                        </td>
                        <td style={td_icon_style}>
                          <span className="ti ti-circle-arrow-down pointer" onClick={() => { this.changeFields(idx, "down") }}></span>
                        </td>
                        <td style={td_icon_style}>
                          <span className="ti ti-trash text-danger pointer" onClick={() => { this.changeFields(idx, "trash") }}></span>
                        </td>
                      </tr>
                    }
                  })}
                </tbody>
              </table>

              {disabled_cols && <div>
                <h5>Отключенные параметры</h5>
                {disabled_cols}
              </div>}

            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary p-2 me-1" onClick={this.applyChange} data-bs-dismiss="modal">
                <span className="ti ti-check me-1"></span>
                Применить
              </button>
              <button type="button" className="btn btn-danger p-2 me-1" onClick={() => { this.applyChange("reset") }} data-bs-dismiss="modal">
                <span className="ti ti-trash me-1"></span>
                Сброс
              </button>
              <button type="button" className="btn btn-secondary p-2 me-1" data-bs-dismiss="modal">
                Закрыть
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
